import { ShipmentQuery } from '../models/shipment-query';
import { FilterCondition } from '../models/filter-condition';

export function shipmentQueryEqual(a: ShipmentQuery, b: ShipmentQuery): boolean {
    if (a.state !== b.state) {
        return false;
    }
    if (a.sortColumn !== b.sortColumn) {
        return false;
    }
    if (a.sortDescending !== b.sortDescending) {
        return false;
    }
    if (a.afterDate !== b.afterDate) {
        return false;
    }
    if (a.beforeDate !== b.beforeDate) {
        return false;
    }
    if (a.filter !== b.filter) {
        return false;
    }
    if (a.courier !== b.courier) {
        return false;
    }
    if (a.serviceId !== b.serviceId) {
        return false;
    }
    if (a.batchId !== b.batchId) {
        return false;
    }
    if (!filterConditionsEqual(a.shipper, b.shipper)) {
        return false;
    }
    if (!filterConditionsEqual(a.destination, b.destination)) {
        return false;
    }
    return true;
}

function filterConditionsEqual(a: FilterCondition[], b: FilterCondition[]): boolean {
    let c = 0;
    for (let i = 0; i < a.length; i++) {
        for (let j = 0; j < b.length; j++) {
            if (a[i].property === b[j].property) {
                c++;
                if (a[i].value !== b[j].value) {
                    return false;
                }
                if (a[i].operator !== b[i].operator) {
                    return false;
                }
            }
        }
    }
    return c === a.length;
}
